var InterleavedStereoRenderMethod = (function () {
    function InterleavedStereoRenderMethod() {
    }
    return InterleavedStereoRenderMethod;
}());
export { InterleavedStereoRenderMethod };
